<template>
    <v-row justify="center">
        <v-dialog v-model="dialog" persistent max-width="950px">
            <template v-slot:activator="{ on, attrs }">
                <v-fab-transition>
                    <v-btn color="primary" dark fixed bottom right fab v-bind="attrs" v-on="on">
                        <v-icon large>mdi-phone</v-icon>
                    </v-btn>
                </v-fab-transition>
            </template>
            <v-card>
                <!-- <v-card-title>
                    <span class="headline">Contactar con ventas</span>
                </v-card-title> -->
                <v-card-text>
                    <v-row no-gutters align="center" justify="center">
                        <v-img
                            src="/static/images/calling.svg"
                            max-width="300"
                            class="mt-10"
                        >
                        </v-img>
                    </v-row>
                    <v-row no-gutters>
                        <v-col cols="12" xl="12" class="text-center mt-4">
                            <v-card-text>Contáctanos de manera rápida</v-card-text>
                            <v-btn large rounded color="primary" href="tel:51958805900">
                                <v-icon small left>mdi-phone</v-icon>
                                    Llamar +51 958 805 900
                            </v-btn>
                        </v-col>
                        <v-col cols="12" xl="12" class="text-center mt-4">
                            <v-btn large rounded color="success" href="https://wa.me/51958805900" target="_new">
                                <v-icon small left>mdi-whatsapp</v-icon>
                                Contactar por WhatsApp
                            </v-btn>
                        </v-col>
                    </v-row>
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="error darken-1" text @click="dialog = false">Cerrar</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </v-row>
</template>

<script>
export default {
    data: () => ({
        dialog: false,
    }),
};
</script>
